// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  max-height: calc(100vh - 20rem);
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 14rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/filming-modal/filming-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AACF","sourcesContent":[".form-container {\n  max-height: calc(100vh - 20rem);\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 14rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
